import React, { FC, useEffect } from 'react';
import {
  trackCtaClicked,
  trackCtaViewed,
  CtaEventDataType,
  CTA_TYPES,
} from '@zola-helpers/client/dist/es';

import { Banner, Text, StyledLink } from './CustomizableBanner.styles';

const createTrackingPayload = (): CtaEventDataType => {
  return {
    business_unit: 'CORE',
    group_id: 'EXTRACUSTOMIZABLE_DESIGN',
    cta_type: CTA_TYPES.LINK,
    cta: 'Customize',
    cta_id: 'customize_design_website_edit_homepage',
    location: 'WEBSITE',
    section: 'WEBSITE_EDIT_HOMEPAGE',
    position: 0,
  };
};

const CustomizableBanner: FC = () => {
  // Variables + State
  const customizeURL = '/wedding/manage/website/customize';
  const textContent = "🎨 This design's fonts and colors are *extra* customizable.";

  // Methods

  // Event Handlers

  // Hooks
  useEffect(() => {
    trackCtaViewed(createTrackingPayload());
  }, []);

  // Render
  return (
    <Banner>
      <Text>{textContent}</Text>
      <StyledLink
        variant="primary"
        href={customizeURL}
        arrow
        arrowPosition="postfix"
        onClick={() => {
          trackCtaClicked(createTrackingPayload());
        }}
      >
        Customize
      </StyledLink>
    </Banner>
  );
};

export default CustomizableBanner;
